// extracted by mini-css-extract-plugin
export default {"CountDiv":"styles_CountDiv__opQwJ","CountText":"styles_CountText__467zh","CountChangebleDiv":"styles_CountChangebleDiv__p+u9i"};